import MailIcon from "@mui/icons-material/MailOutlineRounded";
import { Stack, TextField, Typography } from "@mui/material";
import useUserContext from "../../../context/useUserContext";

const UserProfileSection = () => {
  const { name, email } = useUserContext();

  return (
    <Stack spacing={2}>
      <Typography variant="subtitle1" sx={{ py: 2 }}>
        Profile
      </Typography>
      <Stack direction="row" spacing={2}>
        <TextField label="Full Name" value={name} disabled fullWidth />
        <TextField
          label="Email"
          value={email}
          disabled
          fullWidth
          slotProps={{
            input: { startAdornment: <MailIcon color="action" sx={{ mr: 1 }} /> },
          }}
        />
      </Stack>
    </Stack>
  );
};

export default UserProfileSection;
